import { render } from "./PlotMonitoring.vue?vue&type=template&id=1ac3bfc0"
import script from "./PlotMonitoring.vue?vue&type=script&lang=js"
export * from "./PlotMonitoring.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__